import L from "leaflet";

L.ClusterIcon = L.DivIcon.extend({
  setColor: function(color) {
    this.dom.style.backgroundColor  = color;
  },
  isDomExists: function() {
    if (this.dom !== undefined) {
      return true;
    } else {
      return false;
    }
  },
  createIcon: function() {
    var div = document.createElement("div");
    div.style.display = 'block';
    div.style.position = 'absolute';
    div.style.width =  '32px';
    div.style.height = '32px';
    div.style.borderRadius = '23px';
    div.style.backgroundColor  = this.options.color;
    div.style.backgroundImage = 'url("/img/czujnik_powietrza.png")';
    div.style.backgroundSize = "cover";
    div.style.fontSize = '25px';
    div.style.color = "white";
    div.style.textAlign = "center";
    div.style.verticalAlign = "middle";

    div.append(this.options.number);

    this.dom = div;
    this._setIconStyles(this.dom, 'div');

    return this.dom;
  }
});

L.clusterIcon = function(options) {
  return new L.ClusterIcon(options);
};


